var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4005 2.52632V7.57895C3.4005 8.97684 4.56203 10.1053 6.00092 10.1053C7.43982 10.1053 8.60135 8.97684 8.60135 7.57895V2.52632C8.60135 1.12843 7.43982 0 6.00092 0C4.56203 0 3.4005 1.12843 3.4005 2.52632Z",
    fill: "#00C880"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9906 8.53895C12.0686 8.03368 11.6525 7.57895 11.1238 7.57895C10.699 7.57895 10.3436 7.88211 10.2743 8.29474C9.91889 10.2821 8.14194 11.7895 6.00092 11.7895C3.8599 11.7895 2.08295 10.2821 1.72757 8.29474C1.65821 7.88211 1.30283 7.57895 0.87809 7.57895C0.349334 7.57895 -0.0754038 8.03368 0.0112811 8.53895C0.436019 11.0653 2.51636 13.0358 5.13411 13.4063V15.1579C5.13411 15.621 5.52419 16 6.00092 16C6.47766 16 6.86773 15.621 6.86773 15.1579V13.4063C9.48549 13.0358 11.5658 11.0653 11.9906 8.53895Z",
    fill: "#00C880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/Record.3e639bcb94b8280c0b3a5f0cc33f4732.svg";
export { ForwardRef as ReactComponent };